
import { Badge } from "@/components/ui/badge";

export const getStatusBadge = (status: string) => {
  switch (status) {
    case "published":
      return <Badge className="bg-green-500">Published</Badge>;
    case "draft":
      return <Badge variant="outline" className="text-gray-500">Draft</Badge>;
    case "review":
      return <Badge className="bg-yellow-500">In Review</Badge>;
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

export const getRoleBadge = (role: string) => {
  switch (role) {
    case "admin":
      return <Badge className="bg-purple-500">Admin</Badge>;
    case "user":
      return <Badge variant="outline" className="text-gray-500">User</Badge>;
    default:
      return <Badge variant="outline">{role}</Badge>;
  }
};

export const getSubscriptionBadge = (subscription: string) => {
  switch (subscription) {
    case "enterprise":
      return <Badge className="bg-ai-indigo">Enterprise</Badge>;
    case "pro":
      return <Badge className="bg-premium">Pro</Badge>;
    case "basic":
      return <Badge variant="outline" className="text-gray-500">Basic</Badge>;
    default:
      return <Badge variant="outline">{subscription}</Badge>;
  }
};
